// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardComponentHeading-root-0300b57851089b7e620cf143aca2bded"};